const config = {
	activeFilter: document.querySelector('.party-starters__button--active'),
};

/**
 *
 */
const initPartyStartersFilters = () => {
	const filters = document.querySelectorAll('.party-starters__button');
	const partyStarters = document.querySelectorAll('.party-starters__item');
	
	
	if (filters.length > 0) {
		
		filters.forEach((filter) => {
			filter.addEventListener('click', (evt) => {
				if (!filter.classList.contains('party-starters__button--active')) {
					if (config.activeFilter) {
						config.activeFilter.classList.remove('party-starters__button--active')
					}
					filter.classList.add('party-starters__button--active');
					
					config.activeFilter = filter;
					const filterSlug = filter.dataset.category;
					
					partyStarters.forEach((partyStarter) => {
						if (!partyStarter.classList.contains('party-starters__item--disabled')) {
							partyStarter.classList.add('party-starters__item--disabled');
						}
					});
					
					setTimeout(() => {
						partyStarters.forEach((partyStarter) => {
							if (partyStarter.classList.contains(filterSlug)) {
								partyStarter.classList.remove('party-starters__item--hidden');
								
								setTimeout(() => {
									partyStarter.classList.remove('party-starters__item--disabled');
								}, 400);
							} else {
								partyStarter.classList.add('party-starters__item--hidden');
							}
						});
					}, 400);
				}
			});
		});
	}
};

export default initPartyStartersFilters;
